import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ContentService, SeoService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { Subject } from 'rxjs';

@Component({
  selector: 'lcp-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit, OnDestroy {
  // jobListing: TypeJobListingFields | null = null;
  route$: any
  filter$: any
  // filterLookup: any
  project: any
  projectFeaturedMedia: any[]
  projectTags: any[]

  destroy$: Subject<boolean> = new Subject<boolean>();

  
  constructor(
    public contentService: ContentService,
    public lcpHelper: LcpHelper, 
    public route: ActivatedRoute,
    private seoService: SeoService
  ) { }

  ngOnInit(): void {
    this.route$ = this.routeStream()
    // this.filter$ = this.filtersStream()
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  routeStream() {
    return this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.contentService.getProjectsBySlug(params.get('slug') as string)
      ))
      .pipe(takeUntil(this.destroy$))
      .subscribe({
       next: (projects) => {
        this.project = projects.items[0]
        if (!this.project) return this.seoService.update({ title: 'project not found', noindex: true })
        const title = this.project.fields['title']
        const description = SeoService.text(this.project.fields['body'], this.project.fields['tagline'], this.project.fields['subheader'])
        const image = SeoService.image(this.project.fields['media'])
        this.seoService.update({ title, description, image })
        this.seoService.setStructuredData([
          {
            '@type': 'CreativeWork',
            '@id': this.seoService.url() + '#work',
            name: title,
            ...(description ? { description: SeoService.truncate(description, 300) } : {}),
            ...(image ? { image } : {}),
            url: this.seoService.url(),
            creator: SeoService.organizationRef(),
            datePublished: this.project.sys.createdAt,
            dateModified: this.project.sys.updatedAt,
          },
          SeoService.breadcrumbs([['work', '/work'], [title, '/work/' + this.project.fields['slug']]]),
        ])
        this.projectFeaturedMedia = this.project.fields['media'] && this.project.fields['media'][0]
        // console.log('featuredMedia', this.projectFeaturedMedia, this.project.fields)
        this.projectTags = this.project.metadata.tags
        // console.log('fields:', this.project.fields, this.projectFeaturedMedia[0].fields.content_type)
      }})
  }

  // filtersStream() {
  //   return this.contentService.getFilters()
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(filters => {
  //     // let filterLookupTemp:any = {}
  //     filters.items.map(x => { 
  //       if (x.fields['type'] !== 'tag' || !x.fields['name']) return
  //       let name: any = x.fields['name']
  //       delete x.fields['name']
  //       // filterLookupTemp[name]= x.fields
  //     })
  //     // this.filterLookup = filterLookupTemp
  //     // console.log('filterLookup', this.filterLookup, pt, this.filterLookup[pt])
  //   })
  // }
  
}
